import LineOutput   from './LineOutput';

export default class RawLine extends LineOutput {

    output() {
        return this.decorator.output()
    }
}